export default "__VITE_ASSET__B8d8DLPW__"